var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from "../../Button/Button";
var FormLayoutFooterOptions = function (_a) {
    var cancelText = _a.cancelText, onCancel = _a.onCancel, submitText = _a.submitText, disabled = _a.disabled, submitLoading = _a.submitLoading;
    return (_jsxs("div", __assign({ className: "flex justify-end gap-3" }, { children: [_jsx(Button, { htmlType: "button", text: cancelText, onClick: onCancel, type: "white", disabled: disabled }), _jsx(Button, { text: submitText, loading: submitLoading, type: "primary", disabled: disabled })] })));
};
export default FormLayoutFooterOptions;
